export default __webpack_public_path__ + "static/media/ep1collage3.0675eebe.jpg";